export default "__VITE_ASSET__B2HUtZ8Q__"